import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../intialStates/user/index";
import { notification_Actions_Layout } from "../actions/notifications";
import { system_layout_actions } from "../actions/systemEvent";
import { controls_layout_actions } from "../actions/controls";
import { currentPremission2 } from "../../../constants";
import { PermissionsType } from "../../../types";
export type UserSliceType = {
  user: {
    timeFormat: any;
    status: string;
    clubs: {}[];
    selectedClub: number;
    id: string;
    notification: boolean;
    darkMode: boolean;
    auth: boolean;
    has_manual_price_role: boolean;
    pos_manual_price: boolean;
    currentPremission: PermissionsType | [];
    loading: boolean;
    lang: string;
    error: null;
  };

  timeFormat: number;
  stage: string;
  dictionary: any;
  status: string;
  clubs: {}[];
  selectedClub: number;
  id: string;
  notification: boolean;
  darkMode: boolean;
  auth: boolean;
  loading: boolean;
  error: null;
};
export const userSlice = createSlice({
  name: "user",
  initialState,
  //@ts-ignore
  reducers: {
    ...notification_Actions_Layout,
    ...controls_layout_actions,
    ...system_layout_actions,
  },
});

export const selectClubThunk =
  (clubId: number) => (dispatch: any, getState: any) => {
    dispatch(selectClub(clubId)); // Just set selectedClub

    const state = getState();
    const isEnabled = state.user.isEnableRole;
    console.log(isEnabled);
    // just replace false with isEnabled to reactivate the rules
    if (isEnabled) {
      const clubName = state.user.clubs?.find(
        (item: any) => item.club_id === clubId
      )?.club_name;

      const rolesObject = state.user.user?.clubs_roles_list?.find(
        (item: any) => item.club_id === clubId
      );

      const allowedSection = rolesObject?.club_allowed_sections || [];
      const currentPremission = JSON.parse(
        JSON.stringify(rolesObject?.permissions || [])
      );

      currentPremission.forEach((role: any) => {
        if (allowedSection.includes(role.section)) {
          // role.read = true;
        } else {
          role.read = false;
          role.write = false;
          role.create = false;
          role.delete = false;
        }
      });

      dispatch(setCurrentPermission({permissions:currentPremission,has_manual_price_role:rolesObject?.has_manual_price_role,pos_manual_price:rolesObject?.pos_manual_price}));
    } else {
      dispatch(setCurrentPermission({permissions:currentPremission2,has_manual_price_role:false,pos_manual_price:false}));
    }
  };
export const getStatus = (state: UserSliceType) => state.user.status;
export const {
  selectClub,
  setUser,
  setStage,
  setStatus,
  setClubs,
  setDictonary,
  addClub,
  setTimeFormat,
  setLang,
  changePremission,
  setPremission,
  setCurrentPermission,
  ToggleRoleStatus,
  resetUser,
  // setId,
  // setNotification,
  // setDarkMode,
  // setAuth,
  // setLoading,
  // setError
} = userSlice.actions;
export default userSlice.reducer;
